define.alias("shared/components/shared/post/secondary/activity/action", "calendar/components/shared/post/secondary/activity/action");